import { render, staticRenderFns } from "./FilesSection.vue?vue&type=template&id=639ef384&"
import script from "./FilesSection.vue?vue&type=script&lang=js&"
export * from "./FilesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports